import { FlatList, Pressable, StyleSheet, View } from "react-native";
import React, { useEffect, useState } from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../../types/navigationParams";
import { Text, Card, useTheme, Chip, Button, List } from "react-native-paper";
import { OutlinedInput } from "../../components/fields/OutlinedInput";
import { useTranslation } from "react-i18next";

type PickerScreenParams = {
  options: string[];
  onValueChange: (value: any) => void;
  disableSearch?: boolean;
  multiselect?: boolean;
  selectedOptions?: string[];
};

type Props = NativeStackScreenProps<RootStackParamList, "PickerScreen">;
export default function PickerScreen({ route, navigation }: Props) {
  const {
    options,
    onValueChange,
    disableSearch = false,
    multiselect = false,
    selectedOptions = [],
  } = route.params as PickerScreenParams;

  const [searchQuery, setSearchQuery] = useState("");
  const [listOptions, setListOptions] = useState(options);
  const [alreadySelected, setAlreadySelected] = useState<any[]>(
    Array.isArray(selectedOptions) ? selectedOptions : [],
  );
  const theme = useTheme();
  const { t } = useTranslation();

  console.log("options", options);
  console.log("alreadySelected", alreadySelected);

  useEffect(() => {
    const filteredValues = options.filter((o) => !selectedOptions.includes(o));
    console.log("filteredValues", filteredValues);
    setListOptions(filteredValues);
  }, []);

  const onChange = (newValue: any) => {
    if (multiselect) {
      setAlreadySelected((prev) => [...prev, newValue]);
      setListOptions((prev) => prev.filter((item) => item !== newValue));
    } else {
      onValueChange(newValue);
      navigation.goBack();
    }
  };

  const onDelete = (value: string) => {
    setAlreadySelected((prev) => prev.filter((item) => item !== value));
    const deletedItem = options.find((item) => item === value);
    if (deletedItem) {
      setListOptions((prev) => [...prev, deletedItem]);
    }
  };

  const onChangeText = (text: string) => {
    if (text === "") {
      setSearchQuery(text);
      const filteredOptions = options.filter(
        (item) => !alreadySelected.some((selected) => selected === item),
      );
      return setListOptions(filteredOptions);
    }
    setSearchQuery(text);
    setListOptions((prev) =>
      prev.filter((item) => item?.toLowerCase().includes(text.toLowerCase())),
    );
  };

  return (
    <View style={styles.overlay}>
      <Pressable onPress={() => navigation.goBack()} style={{ flex: 1 }} />
      <Card style={styles.card}>
        <Card.Content style={{ maxHeight: 500 }}>
          {multiselect && (
            <View style={styles.chipContainer}>
              {alreadySelected.map((item) => (
                <Chip
                  key={item}
                  onClose={() => onDelete(item)}
                  style={styles.chip}
                  textStyle={styles.chipText}
                >
                  {t(item)}
                </Chip>
              ))}
            </View>
          )}
          {!disableSearch && (
            <OutlinedInput
              placeholder="Search"
              style={{ zIndex: 60 }}
              value={searchQuery}
              onChangeText={onChangeText}
            />
          )}
          <FlatList
            ListEmptyComponent={() => (
              <View style={{ padding: 16 }}>
                <Text style={{ textAlign: "center" }}>
                  {t("Nothing found")}
                </Text>
              </View>
            )}
            style={{
              borderColor: theme.colors.outlineVariant,
              borderWidth: 1,
              backgroundColor: theme.colors.secondaryContainer,
              borderRadius: 15,
              borderTopRightRadius: disableSearch ? 15 : 0,
              borderTopLeftRadius: disableSearch ? 15 : 0,
            }}
            data={listOptions}
            renderItem={({ item, index }) => {
              return (
                <List.Item title={t(item)} onPress={() => onChange(item)} />
              );
            }}
          />
          {multiselect && (
            <Button
              mode="contained"
              testID="save"
              style={styles.buttonSave}
              onPress={() => {
                onValueChange(alreadySelected);
                navigation.goBack();
              }}
            >
              {t("Save")}
            </Button>
          )}
        </Card.Content>
      </Card>
      <Pressable onPress={() => navigation.goBack()} style={{ flex: 1 }} />
    </View>
  );
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
  },
  card: {
    margin: 20,
    paddingBottom: 10,
    maxWidth: 500,
    alignSelf: "center",
    width: "100%",
  },
  chipContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginVertical: 10,
    rowGap: 10,
  },
  chip: {
    marginRight: 10,
  },
  chipText: {
    fontSize: 12,
  },
  buttonSave: {
    marginTop: 15,
  },
});
